import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import Header from './HeaderComponent';

function Home(props){
    return(
        <div>
            <Header destination="Data Structures and Algorithm Visualizer"/>
            <div className="container">
                <div className="row mb-2">
                    <div className="col-12 col-md-6">
                        <Card className="p1">
                            <CardHeader style={{background: "#D1C4E9"}}>
                                <h4>Problem Identification</h4>
                            </CardHeader>
                            <CardBody className="text-justify">
                                COVID-19 has come as a big problem for many people. Not only are we facing employment issues, our country is looking at one of the worst times for our economy.
                                With all this, the students and teachers are facing a different problem alltogether. It has become a very difficult task for teachers
                                to teach students without being physically present in the class. The students are also facing difficulties in comprehending what the
                                teacher is teaching as learning from PPTs is not easy. To tackle this issue, our group has decided to develop a system which can 
                                simulate the behaviour of different algorithms present in computer science. With their simulation, it would be easier for students
                                to understand these contents as teachers can share their screen while explaining them the working as the algorithm executes. Students
                                can also practice on their own if they want to grasp the concept better.
                            </CardBody>
                        </Card>
                    </div>
                    <div className="col-12 col-md-6">
                        <Card className="p-2 p1">
                            The following data structures and algorithms are available currently for visualization:
                            <h6>Data Structures</h6>
                            <ul>
                                <li>Stack</li>
                                <li>Queue</li>
                            </ul>
                            <h6>Algorithms</h6>
                            <ul>
                                <li>Breadth First Search(BFS)</li>
                                <li>Depth First Search(DFS)</li>
                            </ul>
                        </Card>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;